import Scrollbars from 'react-custom-scrollbars';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { set_project_ids, 
    // set_all_projects, 
    setProjects } from '../../redux/taskSlice';
import { isValidConvId } from '../../utils/Common';
import { useQuery } from '@apollo/client';
import { Projects } from '../../graphql/GraphqlQueries';

const LeftBarProject = ({ searchStr, setSearchStr, showNotify, countersdata }) => {
    const dispatch = useDispatch()
    // const projects = useSelector(state => state.task.all_projects) || [];
    const projects = useSelector(state => state.task.projects) || [];
    const project_ids = useSelector(state => state.task.project_ids) || [];
    const user = useSelector(state => state.message.user);
    const navigate = useNavigate();
    // const [projects, setProjects] = useState([]);
    useQuery(Projects, {
        variables: { type: 'for_me' },
        fetchPolicy: 'no-cache',
        onCompleted: (res) => {
            if (res.projects.status) {
                console.log("Projects fetched successfully:", res.projects.data);
                dispatch(setProjects(res.projects.data));
                // dispatch(set_all_projects(res.projects.data))
            }
        }
    });

    const filteredProjects = projects.filter((project) => {
        return (
            project.project_title &&
            project.project_title.toLowerCase().includes(searchStr.toLowerCase())
        );
    });

    const handleBack = () => {
        debugger
        const last_conv = localStorage.getItem('last_active_conv')
        setSearchStr('');
        // navigate(-1);
        navigate(`/connect/${isValidConvId(last_conv) ? last_conv : user?.id}`)
    };


    return (
        <div className='border-t border-t-border-intermediary dark:!border-[#ffffff42]'>
            <div onClick={handleBack} className="bactToAllProject border-b dark:!border-[#ffffff42] border-b-border-intermediary !px-[20px] font-bold thread_back text-[#BFDCFF] ">
                <span className="project_icon"></span>
                <span className='font-bold text-text-bodyDark'>Projects</span>
            </div>
            <div className='group_container mt-[10px] archiveLastChild projectListTask  !overflow-y-auto'
                style={
                    showNotify && countersdata?.notificationcount > 0
                        ? { height: "calc(100vh - 378px)" }

                        : { height: "calc(100vh - 332px)" }
                }
            >
                <Scrollbars
                    className="custom-scrollbars"
                    renderThumbVertical={({ style, ...props }) => (
                        <div className="track"
                            {...props}
                            style={{
                                ...style,
                                backgroundColor: "#0B1F47",
                                borderRadius: "50px",
                            }}
                        />
                    )}
                    autoHide={false}
                >
                    {filteredProjects.length > 0 ? (
                        filteredProjects.map((v) => (
                            <li key={'_pro' + v._id} onClick={() => dispatch(set_project_ids([v._id]))} className={`conv_list !pl-[20px] ${project_ids?.[0] === v._id ? 'selected' : ''}`}>
                                <span className="project_icon"></span>
                                <span className="conv_list_title" title={v.project_title}>
                                    {v.project_title}
                                </span>
                            </li>
                        ))
                    ) : (
                        <p className="no-projects-message text-[#fff] text-center pt-10">No projects found.</p>
                    )}
                </Scrollbars>
            </div>
        </div>
    );
};

export default LeftBarProject;
